var map = {
	"./diamond-color-1@2x.png": 66,
	"./diamond-color-2@2x.png": 68,
	"./diamond-color-3@2x.png": 70,
	"./diamond-color-4@2x.png": 72,
	"./diamond-color-5@2x.png": 74,
	"./diamond-color-table@2x.png": 76,
	"./diamond-color-table_over-md@2x.png": 78
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 253;